<script setup>

</script>

<template>
  <div class="pt-6 pb-6 lg:pt-0 lg:pl-6 first:lg:pl-0 first:lg:pr-6 bg-white print:group-[.with-print]/columns:bg-transparent">
    <slot />
  </div>
</template>
